import React from 'react';
import { ShieldCheck } from 'lucide-react';
import { Tarjeta, TituloSeccion } from '../components/ui/Tarjeta';
import { SECCIONES_AYUDA, TEXTO_ACEPTACION, TEXTO_ALCANCE } from '../data/textos';
import { CATALOGO } from '../data/catalogo';
import { useDatos } from '../contexts/DatosContext';
import { Aviso } from '../components/ui/Aviso';
export function Ayuda() {
  const {
    almacenamientoOk,
    aceptado
  } = useDatos();
  return <div className="space-y-5" data-id="element-436" data-mp="3nao33luceaun">
      <TituloSeccion nivel={1} descripcion="Alcance, límites y funcionamiento de la herramienta." data-id="element-437" data-mp="3ne27ezmkgu4q">
        Ayuda y seguridad
      </TituloSeccion>

      <section className="rounded-2xl bg-vino-oscuro p-6 text-white" data-id="element-438" data-mp="3dlec69b8iy84">
        <div className="flex items-center gap-2 text-sm font-semibold text-white/70" data-id="element-439" data-mp="38ncqrhqc6mth">
          <ShieldCheck className="h-4 w-4" aria-hidden="true" data-id="element-440" data-mp="38l8m2xkm5js5" />
          Alcance
        </div>
        <p className="mt-2 text-sm leading-relaxed text-white/90" data-id="element-441" data-mp="9yxhjwu77fg4">{TEXTO_ALCANCE}</p>
      </section>

      <Tarjeta data-id="element-442" data-mp="54jfjbl16a2h">
        <h2 className="text-lg font-bold text-tinta-titulo" data-id="element-443" data-mp="2ssj40nytddjr">Aceptación registrada</h2>
        <p className="mt-2 text-sm text-tinta-sec" data-id="element-444" data-mp="2xrdv0d6xq8ey">{TEXTO_ACEPTACION}</p>
        <p className="mt-3 text-sm font-semibold text-verde" data-id="element-445" data-mp="2xqkjkyx16uqh">
          {aceptado ? 'Aceptado y guardado en este dispositivo.' : 'Todavía no hay una aceptación registrada en este dispositivo.'}
        </p>
      </Tarjeta>

      {!almacenamientoOk && <Aviso tipo="alerta" titulo="Almacenamiento no disponible" data-id="element-446" data-mp="2a1026kgj05jb">
          El navegador no permite guardar datos locales. Podés usar la herramienta, pero los datos
          se pierden al cerrar la pestaña. Revisá la configuración de privacidad o probá fuera del
          modo privado.
        </Aviso>}

      <div className="grid grid-cols-1 gap-3 md:grid-cols-2" data-id="element-447" data-mp="25386dfcrfz9u">
        {SECCIONES_AYUDA.map(s => <Tarjeta key={s.titulo} className="h-full" data-id="element-448" data-mp="3uifrc6p42t98">
            <h2 className="text-base font-bold text-tinta-titulo" data-id="element-449" data-mp="3bv30uqfxzfw">{s.titulo}</h2>
            <p className="mt-2 text-sm text-tinta-sec" data-id="element-450" data-mp="1twisj7dllh7">{s.texto}</p>
          </Tarjeta>)}
      </div>

      <Tarjeta data-id="element-451" data-mp="3szxy53ydj18n">
        <h2 className="text-base font-bold text-tinta-titulo" data-id="element-452" data-mp="3t07lskvy4wb6">Catálogo base</h2>
        <p className="mt-2 text-sm text-tinta-sec" data-id="element-453" data-mp="3o0ur5dyu2ky1">
          La biblioteca contiene {CATALOGO.length} recursos base con identificadores únicos. Los
          textos de objetivo, prerrequisitos, regresión, progresión, clave docente y seguridad se
          usan tal como están definidos en el catálogo, sin generar contenido adicional.
        </p>
      </Tarjeta>
    </div>;
}